import { render, staticRenderFns } from "./H2.vue?vue&type=template&id=04880592&lang=pug&"
import script from "./H2.vue?vue&type=script&lang=js&"
export * from "./H2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports